module.exports = __webpack_public_path__ + "img/development-during-recession-top.55515c51.jpeg";